import { render, staticRenderFns } from "./FmlCheckboxEditor.vue?vue&type=template&id=15ce92f2&"
import script from "./FmlCheckboxEditor.vue?vue&type=script&lang=js&"
export * from "./FmlCheckboxEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports